import { Component, OnInit, Input } from "@angular/core";
import _ from "lodash";
import * as moment from "moment";
import { SynTaskService } from "./syn-task.service";
import { Router } from "@angular/router";
import { NzModalRef } from "ng-zorro-antd/modal";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";

@Component({
  selector: "host-syn-task-list",
  templateUrl: "./syn-task-list.component.html",
  styleUrls: ["./syn-task-list.component.scss"],
})
export class SynTaskListComponent implements OnInit {
  @Input() taskType: 1 | 0 = 0;
  getTaskListParams = {
    page: 1,
    page_size: 20,
    is_failed: null,
  };
  taskList = [];
  total = 9999;
  pageIndex = 1;
  loading = false;
  constructor(
    private synService: SynTaskService,
    private router: Router,
    private subject: NzModalRef,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.getTaskList();
  }

  chooseAllTask() {
    this.taskType = 0;
    _.assign(this.getTaskListParams, {
      is_failed: null,
      page: 1,
    });
    this.getTaskList();
    this.pageIndex = 1;
  }

  chooseFailedTask() {
    this.taskType = 1;
    _.assign(this.getTaskListParams, {
      is_failed: 1,
      page: 1,
    });
    this.getTaskList();
    this.pageIndex = 1;
  }

  getTaskList() {
    // this.loading = true;
    if (this.taskType) {
      _.assign(this.getTaskListParams, {
        is_failed: 1,
      });
    }
    console.log('inner start');
    
    this.synService.getTaskList(this.getTaskListParams).subscribe((res) => {
      if (res.error_code === 0) {
        this.loading = false;
        this.taskList = _.get(res, "data.list");
        this.formatTaskList();
        // this.total = _.get(res, "data.count");
      }
    });
  }

  formatTaskList() {
    _.forEach(this.taskList, (task) => {
      const status = _.get(task, "sync_status");
      let _status;
      let _color;
      switch (status) {
        case 0:
          // 等待中
          _status = this.translateService.syncGet("syn_task.waiting");
          _color = "#F5A623";
          break;
        case 1:
          // 执行中
          _status = this.translateService.syncGet("syn_task.in_progress");
          _color = "#2C80F0";
          break;
        case 2:
          // 成功
          _status = this.translateService.syncGet("word.success");
          _color = "#6BB935";
          break;
        case 3:
          // 失败
          _status = this.translateService.syncGet("word.fail");
          _color = "#F45A5A";
          break;
      }
      _.forEach(task.change, (change) => {
        _.assign(change, {
          from:
            change.from === true
              ? // 打开
                this.translateService.syncGet(
                  "component.month_calendar_v2.open"
                )
              : change.from === false
              ? // 关闭
                this.translateService.syncGet("word.close")
              : change.from,
          to:
            change.to === true
              ? this.translateService.syncGet(
                  "component.month_calendar_v2.open"
                )
              : change.to === false
              ? this.translateService.syncGet("word.close")
              : change.to,
        });
      });
      _.assign(task, {
        status: _status,
        color: _color,
      });
    });
  }

  pageChange() {
    _.assign(this.getTaskListParams, {
      page: this.pageIndex,
    });
    this.getTaskList();
  }

  // @WritePermissionGurd("calendar")
  retry(task) {
    this.synService
      .retryTask({
        id: task.id,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.getTaskList();
        }
      });
  }

  toHouseStatusDetail(task) {
    console.log(task);
    if (task.house_type_id) {
      const id = task.house_type_id;
      this.router.navigate(["/app/room_types/detail"], {
        queryParams: {
          id: id,
          type: "type",
          activeIndex: 2,
          unique_key: task.thirdparty_house_id,
        },
      });
    } else {
      const id = task.house_id;
      this.router.navigate(["/app/properties/detail"], {
        queryParams: {
          id: id,
          type: "house",
          activeIndex: 2,
          unique_key: task.thirdparty_house_id,
        },
      });
    }
    this.subject.destroy();
  }

  toHousePriceDetail(task) {
    if (task.house_type_id) {
      const id = task.house_type_id;
      this.router.navigate(["/app/room_types/detail"], {
        queryParams: {
          id: id,
          activeIndex: 2,
        },
      });
    } else {
      const id = task.house_id;
      this.router.navigate(["/app/properties/detail"], {
        queryParams: {
          id: id,
          activeIndex: 2,
        },
      });
    }
    this.subject.destroy();
  }

  formatDate(date) {
    return moment(date).format("MM.DD");
  }
}
